module.exports = __webpack_public_path__ + "img/x.b29b9177.svg";